module.exports = "/dist/assets/images/Calendar.svg";